// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox___QSFTTp1a","checkbox__indicator":"checkbox__indicator___i5fA7v8X","checkbox--error":"checkbox--error___o0w_Tg4R"};